import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function Profile() {
    const { t } = useTranslation();
    const userDetails = useSelector((store) => store.loginSession?.value);

    const { firstName, lastName, title, email, role } = userDetails;

    return (
        <div className="profile-readonly-block show">
            <div className="inner-heading flex">
                <div className="left">
                    <h4>{t("my_account.personal_information")}</h4>
                </div>
            </div>
            <div className="profile-info-details">
                <ul className="flex">
                    <li>
                        <label>{t("my_account.first_name")}</label>
                        <span>{firstName}</span>
                    </li>
                    <li>
                        <label>{t("my_account.last_name")}</label>
                        <span>{lastName}</span>
                    </li>
                    <li>
                        <label>{t("my_account.title")}</label>
                        <span>{title}</span>
                    </li>
                    <li>
                        <label>{t("my_account.email")}</label>
                        <span>{email}</span>
                    </li>
                </ul>
            </div>
            <div className="role-and-department">
                <h5 className="heading-width-border">Role</h5>
                <ul className="role">
                    <li>
                        <label>{t("my_account.role")}</label>
                        <span>{role?.[0]?.displayName}</span>
                    </li>
                </ul>
            </div>
        </div>
    );
}